import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexProfilesRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/profiles', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const createProfileRequest = ({ dispatch, params, formData, failureCallback, successCallback }) => {
  ApiService.request('post', '/profiles', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const duplicateProfileRequest = (id, { dispatch, params, formData, failureCallback, successCallback }) => {
  ApiService.request('post', `/profiles/${id}/duplicate`, {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const showProfileRequest = (id, { dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', `/profiles/${id}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const updateProfileRequest = (id, { dispatch, params, formData, failureCallback, successCallback }) =>
  ApiService.request('put', `/profiles/${id}`, {
    dispatch,
    params,
    formData,
    successCallback,
    failureCallback
  });

export const deleteProfileRequest = (id, { dispatch, failureCallback, successCallback }) =>
  ApiService.request('delete', `/profiles/${id}`, {
    dispatch,
    failureCallback,
    successCallback
  });

export const debounceIndexProfilesRequest = AwesomeDebouncePromise(indexProfilesRequest, 300);
